import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { IconX } from '@tabler/icons-react';

import IconButton from './IconButton';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  size?: 'sm' | 'md';
  footer?: React.ReactNode;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  open,
  onClose,
  title,
  size = 'sm',
  footer,
  children,
}) => (
  <Dialog.Root open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
    <Dialog.Portal>
      <Dialog.Overlay className="rr-overlay" />
      <Dialog.Content
        className={['rr-modal', size === 'md' ? 'rr-modal-md' : ''].filter(Boolean).join(' ')}
      >
        <div className="rr-modal-header">
          <Dialog.Title className="rr-modal-title">{title}</Dialog.Title>
          <Dialog.Close asChild>
            <IconButton icon={<IconX size={18} />} aria-label="Close" />
          </Dialog.Close>
        </div>
        <div className="rr-modal-body">{children}</div>
        {footer && <div className="rr-modal-footer">{footer}</div>}
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);

export default Modal;
